import themeGet from '@styled-system/theme-get';

// TODO: enhance this function once we will have more use cases
export const linearGradient =
  (angle = '90deg', colors = []) =>
  (props) => {
    const theme = props.theme ?? props;
    const checkArrType = ([firstItem]) => typeof firstItem;
    const getValue = (token) => {
      return themeGet(`colors.${token}`)({ theme }) || token;
    };
    const fns = {
      object: ({ token, position }) => `${getValue(token)} ${position}`,
      string: (token) => getValue(token),
    };

    if (colors.length === 0) {
      throw new Error('linearGradient colors array cannot be empty');
    }

    const colorsType = checkArrType(colors);

    return `linear-gradient(${angle}, ${colors
      .map((color) => fns[colorsType](color))
      .join(',')})`;
  };
